var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLittleArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6663 13.1695C24.0443 13.5475 23.7766 14.1938 23.242 14.1938L2 14.1938C1.2268 14.1938 0.599999 14.8206 0.599999 15.5938L0.599999 16.4063C0.599999 17.1795 1.2268 17.8063 2 17.8063L23.242 17.8063C23.7766 17.8063 24.0443 18.4525 23.6663 18.8305L14.4555 28.0413C13.9088 28.588 13.9088 29.4745 14.4555 30.0212L15.0101 30.5757C15.5568 31.1225 16.4432 31.1225 16.99 30.5757L30.5757 16.9899C31.1225 16.4432 31.1225 15.5568 30.5757 15.01L16.9899 1.42427C16.4432 0.87753 15.5568 0.87753 15.01 1.42427L14.4555 1.9788C13.9088 2.52554 13.9088 3.41197 14.4555 3.9587L23.6663 13.1695Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLittleArrow);
export default __webpack_public_path__ + "static/media/littleArrow.3461a8e4fe7b3841f5467f3f0ab682c9.svg";
export { ForwardRef as ReactComponent };